var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCirclebgGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1334,
    height: 1136,
    viewBox: "0 0 1334 1136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_89_3638",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 195,
    y: 166,
    width: 944,
    height: 804
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1000.5 852C1184.69 695.151 1184.69 440.849 1000.5 284C816.313 127.151 517.687 127.151 333.5 284C149.313 440.849 149.313 695.151 333.5 852C517.687 1008.85 816.313 1008.85 1000.5 852Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_89_3638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.593 233.204C280.909 226.313 372.578 195.564 472.624 188.322C543.382 183.215 612.079 169.245 683.313 167.381C874.616 162.355 1067.16 167.273 1258.55 167.381",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.469 246.228C279.801 238.176 372.39 212.101 471.167 204.427C543.354 198.807 612.272 182.324 685.061 180.379C875.19 175.272 1068.27 180.865 1258.59 182.081",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.084 256.658C277.64 248.876 372.355 230.205 468.847 221.315C543.794 214.398 613.601 192.754 689.532 190.728C771.841 188.512 852.563 200.995 934.649 201.725C1042.69 202.698 1150.57 196.132 1258.62 196.78",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.514 264.953C274.881 258.549 372.102 249.362 465.802 238.851C544.62 230.015 615.792 200.941 696.165 198.888C778.695 196.78 857.133 217.64 939.029 220.477C1045.64 224.179 1151.97 211.452 1258.55 211.452",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.82 271.546C272.759 267.304 370.107 267.52 462.284 256.847C546.021 247.146 618.588 207.156 704.641 205.291C787.774 203.508 862.975 234.149 944.713 239.986C1049.23 247.444 1154.13 227.178 1258.59 226.124",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.99 276.923C270.12 275.464 368.166 288.488 458.312 275.248C546.967 262.251 622.358 211.776 714.313 210.479C798.494 209.29 869.633 250.659 951.212 260.116C1052.88 271.924 1156.95 243.228 1258.55 240.824",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.104 281.517C268.218 283.165 364.647 309.835 454.126 293.865C547.414 277.247 627.12 215.154 724.85 214.857C810.427 214.586 876.965 267.088 958.322 280.598C1056.5 296.892 1160.38 259.414 1258.55 255.496",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.211 285.813C267.389 290.785 359.312 331.478 449.839 312.618C547.758 292.217 632.225 219.315 735.729 218.964C822.48 218.667 885.211 283.679 965.711 301.269C1060.14 321.94 1164.09 275.626 1258.58 270.222",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.294 290.218C267.424 298.621 352.398 353.203 445.558 331.289C547.508 307.295 637.78 223.017 746.425 223.152C834.509 223.26 893.4 300.269 972.917 321.832C1063.82 346.475 1167.58 291.677 1258.55 284.894",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.47 295.243C268.059 306.943 344.656 374.846 441.529 349.798C546.969 322.534 643.366 227.232 756.548 227.961C845.996 228.529 901.238 317.022 979.739 342.124C1067.76 370.28 1170.6 307.591 1258.59 299.593",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.708 301.296C269.01 315.887 336.723 395.949 437.816 367.983C546.334 337.963 648.41 232.501 765.559 233.852C856.498 234.906 908.06 333.802 985.799 361.93C1071.76 393.031 1172.91 323.236 1258.59 314.293",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.075 308.862C270.092 325.56 329.3 416.161 434.55 385.709C488.016 370.253 539.673 339.206 587.395 314.536C638.259 288.218 709.462 240.256 772.986 241.256C865.734 242.715 913.234 350.501 990.752 381.007C1075.57 414.378 1174.44 338.557 1258.59 328.965",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.629 318.374C271.454 336.099 322.889 435.049 431.946 402.867C486.871 386.655 540.178 353.582 588.916 327.696C640.256 300.405 713.521 249.498 778.378 250.686C873.316 252.416 916.183 367.038 994.272 399.193C1078.96 434.049 1175.07 353.473 1258.59 343.665",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.375 330.316C273.135 347.61 317.812 452.261 430.105 419.296C485.951 402.894 540.559 368.118 589.741 341.53C641.652 313.482 715.203 261.332 781.202 262.548C878.932 264.386 916.31 383.277 996.017 416.188C1081.66 451.559 1174.69 367.848 1258.55 358.337",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.059 344.827C272.439 362.147 317.75 466.582 429.409 433.374C485.476 416.702 540.306 382.467 590.06 356.013C642.129 328.344 716.188 276.383 781.933 277.113C879.98 278.22 916.216 398.517 995.891 431.293C1082.48 466.933 1174.03 382.169 1258.62 373.009",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.026 360.39C268.819 378.116 320.445 476.363 429.026 443.884C485.316 427.05 540.019 395.355 591.01 369.901C643.46 343.718 719.518 292.892 784.184 293.297C880.01 293.919 917.388 413.459 994.778 446.019C1081.34 482.443 1173.8 396.868 1258.58 387.735",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.345 376.684C264.535 393.491 322.475 482.605 428.518 452.099C485.188 435.778 540.272 406.974 592.627 383.061C645.998 358.688 724.213 310.077 788.15 310.78C881.754 311.78 917.895 428.834 993.064 461.205C1079.24 498.304 1173.8 411.621 1258.55 402.434",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.332 393.545C259.395 408.38 324.188 486.01 427.946 458.476C485.156 443.29 540.97 417.594 594.785 395.734C649.583 373.496 729.861 328.101 793.417 329.479C884.896 331.505 917.832 444.56 990.939 476.742C1076.52 514.409 1174.09 426.348 1258.55 417.107",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.271 410.865C253.334 422.916 325.647 487.387 427.216 463.501C485.092 449.91 541.826 427.563 597.196 408.163C653.739 388.356 735.953 346.934 799.445 349.392C889.052 352.851 916.943 460.961 988.4 492.657C1073.66 530.486 1174.09 441.182 1258.58 431.779",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.546 428.483C246.514 437.183 326.887 487.469 426.426 467.636C485.063 455.963 542.844 437.156 599.673 420.593C658.216 403.543 742.048 366.659 805.73 370.415C895.781 375.711 912.567 480.092 985.578 508.897C1075.12 544.24 1170.38 456.53 1258.62 446.506",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.407 446.29C233.886 450.991 320.224 486.037 412.496 473.445C489.22 462.988 564.453 441.615 639.368 424.511C689.756 413.027 756.612 389.33 809.792 394.572C901.969 403.651 910.631 502.223 990.052 528.595C1076.45 557.318 1173.58 470.716 1258.59 461.205",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.168 464.096C227.631 465.528 318.729 486.199 411.223 476.634C488.74 468.608 565.401 452.612 641.903 439.642C693.94 430.833 761.145 411.135 814.801 417.215C903.583 427.267 910.088 519.272 986.526 544.969C1072.61 573.908 1173.64 485.578 1258.55 475.877",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.221 481.821C222.08 480.173 316.224 486.928 409.923 480.308C488.171 474.796 566.005 464.204 643.808 455.476C697.527 449.451 764.415 433.914 818.769 440.723C904.092 451.396 909.486 536.701 983.101 561.425C1069.15 590.337 1173.58 500.466 1258.58 490.576",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.813 499.305C217.449 494.927 312.894 488.631 408.561 484.929C487.379 481.876 566.07 476.634 644.793 472.149C700.036 468.987 765.971 457.611 821.151 464.961C903.11 475.85 908.758 554.454 979.739 577.854C1066.33 606.442 1173.1 515.355 1258.62 505.276",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.26 516.381C213.736 509.896 309.149 491.819 407.133 490.954C486.268 490.279 565.404 490.198 644.539 489.819C701.083 489.549 765.432 482.254 821.5 489.846C900.318 500.547 907.87 572.449 976.566 594.174C1064.52 621.978 1171.93 530.297 1258.59 519.948",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.916 532.972C211.042 525.244 305.535 497.088 405.676 498.926C539.8 501.412 686.87 497.899 819.345 515.408C895.244 525.46 906.73 590.796 973.713 610.359C1064.11 636.786 1169.93 545.266 1258.56 534.62",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.09 548.887C205.201 541.537 295.316 506.194 392.569 508.734C531.58 512.355 678.492 525.352 816.265 541.159C890.387 549.67 909.806 614.196 978.534 627.787C1072.14 646.324 1167.23 559.992 1258.62 549.319",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.074 564.018C204.978 557.992 293.316 517.515 391.458 521.784C529.897 527.783 669.352 554.696 807.126 567.99C880.074 575.042 908.345 632.353 976.978 643.216C1074.55 658.645 1163.81 575.015 1258.55 564.018",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.183 578.746C205.39 571.45 296.551 534.567 393.9 538.782C528.69 544.592 666.432 566.479 800.334 580.989C873.187 588.879 909.011 645.217 978.437 655.755C1074.74 670.373 1165.14 590.554 1258.58 578.746",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.356 593.472C212.466 585.717 309.656 554.346 410.78 559.615C536.242 566.154 665.512 578.286 790.022 592.823C862.526 601.281 905.171 651.161 973.995 663.915C1071.41 681.938 1164.28 605.631 1258.58 593.418",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.153 608.251C217.706 601.577 317.562 578.961 418.687 582.23C537.739 586.067 661.646 590.985 779.842 603.496C854.694 611.413 906.382 659.131 978.41 671.021C1075.16 686.963 1164.57 619.492 1258.56 608.116",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.307 623.032C337.487 612.981 554.237 595.066 768.798 613.602C847.045 620.357 907.904 665.293 983.993 676.236C1079.41 689.963 1165.43 632.652 1258.59 622.789",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.409 637.839C233.596 635.597 336.847 636.407 440.002 633.003C544.046 629.571 653.23 617.331 757.084 623.572C839.297 628.517 910.024 668.022 990.334 680.154C1082.07 693.989 1168.34 645.189 1258.58 637.488",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.125 652.647C242.581 653.377 348.053 668.103 452.319 660.186C548.557 652.863 648.508 631.057 745.158 633.841C831.655 636.326 912.314 671.778 997.256 683.235C1086.23 695.232 1170.5 657.484 1258.59 652.161",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.119 667.481C250.925 671.291 360.585 700.825 465.073 687.882C553.886 676.884 643.302 645.351 733.321 644.811C824.134 644.27 914.692 675.83 1004.39 686.044C1090.32 695.853 1173.01 669.724 1258.59 666.86",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.052 682.288C260.856 689.314 380.765 735.33 486.808 713.74C563.405 698.149 641.748 656.862 720.915 655.024C812.203 652.89 910.218 678.721 1001 688.044C1087.59 696.933 1171.99 682.126 1258.59 681.586",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.538 697.096C268.755 706.878 391.71 764.783 498.324 740.518C570.511 724.09 633.94 672.75 709.966 668.562C805.189 663.293 911.961 684.91 1007.37 692.07C1091.05 698.339 1174.72 694.529 1258.58 696.231",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.238 711.904C272.821 723.577 405.168 795.533 508.831 766.432C576.385 747.463 627.059 690.395 700.356 684.208C799.228 675.885 913.457 692.719 1013.25 697.448C1095.08 701.339 1176.72 707.418 1258.56 710.931",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.79 726.685C275.772 739.465 416.877 823.554 517.843 790.967C582.128 770.215 620.522 710.04 692.518 702.42C795.071 691.558 914.377 702.609 1018.36 704.69C1099.71 706.311 1177.71 720.902 1258.56 725.658",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.881 741.437C245.847 750.327 303.755 771.538 367.406 792.749C415.763 808.881 473.132 831.443 524.916 813.636C587.361 792.155 615.093 731.871 686.868 723.576C793.418 711.228 914.374 715.146 1022.51 714.254C1104.6 713.578 1177.83 735.06 1258.59 740.329",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.136 756.163C249.372 764.918 306.741 787.615 370.899 810.313C417.765 826.876 478.085 851.168 529.551 833.983C591.553 813.285 611.606 756.136 683.793 748.138C794.595 735.897 913.362 730.899 1025.34 726.656C1108.73 723.522 1177.33 750.11 1258.59 754.974",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.198 770.836C249.656 779.401 306.866 802.369 371.12 825.256C417.7 841.846 478.781 866.111 530.343 850.061C592.344 830.768 611.446 777.213 683.188 769.674C795.641 757.866 912.028 747.625 1025.27 741.221C1109.58 736.438 1176.66 765.108 1258.59 769.674",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.104 785.507C246.768 794.235 304.486 816.203 368.423 838.144C415.542 854.302 475.576 877.648 527.265 862.057C588.822 843.521 611.826 792.397 681.95 784.372C792.658 771.673 906.76 760.864 1018.26 753.082C1104.88 747.03 1174.31 778.104 1258.55 784.372",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.137 800.126C278.086 812.988 417.16 901.643 521.871 872.191C583.205 854.951 611.318 807.611 679.697 799.073C787.644 785.616 897.304 772.673 1005.82 762.621C1096.13 754.272 1170.69 790.21 1258.55 799.073",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.646 814.744C274.055 826.849 408.338 907.75 514.508 880.783C575.747 865.246 610.048 822.823 676.555 813.771C780.757 799.612 884.928 783.562 989.384 770.7C1083.37 759.108 1167.04 801.909 1258.58 813.771",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.015 829.309C269.201 840.198 397.709 912.047 505.719 888.187C566.451 874.758 609.255 839.28 672.779 828.471C771.905 811.583 871.031 794.047 970.41 778.159C1067.09 762.703 1164.16 813.691 1258.59 828.471",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.591 843.9C263.553 853.141 386.191 915.154 495.883 894.78C556.583 883.513 606.558 853.871 668.56 843.144C763.084 826.796 856.467 804.612 950.357 785.833C1048.31 766.215 1162.38 825.931 1258.59 843.144",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.689 858.464C255.366 865.49 368.072 914.614 477.447 901.914C540.939 894.537 599.387 866.571 663.07 856.384C756.865 841.387 846.344 808.233 939.885 792.399C1037.93 775.808 1162.41 839.145 1258.59 857.843",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.695 873.028C247.593 878 357.317 917.451 466.755 907.696C530.533 901.995 594.882 881.054 658.121 870.759C747.886 856.14 832.575 820.365 921.642 802.964C975.488 792.426 1027.59 812.826 1078.9 827.282C1138.58 844.089 1197.41 860.086 1258.62 872.569",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.917 887.592C239.53 890.592 347.382 920.774 456.312 913.722C520.852 909.56 589.77 895.401 653.326 885.242C739.347 871.488 820.45 827.336 906.725 816.42C1015.85 802.612 1151.18 865.192 1258.55 887.241",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.747 902.157C231.694 903.399 338.53 925.043 446.667 920.369C512.444 917.531 584.345 909.479 649.107 899.833C733.414 887.295 812.455 844.467 896.826 833.659C1008.01 819.419 1148.83 880.189 1258.55 901.913",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.531 916.748C294.523 916.613 468.976 937.095 645.619 914.641C729.705 903.94 809.316 865.301 893.37 855.6C1006.71 842.549 1146.42 896.402 1258.55 916.586",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.61 931.366C288.555 929.88 469.006 948.524 644.538 931.285C732.273 922.665 817.818 887.836 905.869 881.54C1018.19 873.515 1147.88 914.938 1258.55 931.285",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.344 946.011C286.527 944.471 465.676 955.198 642.668 946.011C735.48 941.174 827.593 919.585 920.499 916.234C1031.56 912.208 1148.2 935.554 1258.55 946.011",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.074 960.683C491.567 960.359 875.124 957.657 1258.59 960.683",
    stroke: "#12C399",
    strokeOpacity: 0.47,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclebgGreen);
export default __webpack_public_path__ + "static/media/circlebg-green.0b56187e8a7c6a83c5647ca6cc8903f4.svg";
export { ForwardRef as ReactComponent };